import { ClientApi, ToastStateHandler } from '../../../api';
import { useContainer } from '../../useContainer';
import { useEffect, useState } from 'react';
import { useOrganizationId } from '../../state';
import { ClientPublicDto } from '../../../commonTypes/client.types';
import { useTranslation } from '../../useTranslation';

const useHttpGetAllClientsForProjectOnMount = () => {
    const { t } = useTranslation('newNotifications');
    const organizationId = useOrganizationId();
    const clientApi: ClientApi = useContainer(ClientApi);
    const [clients, setClients] = useState<ClientPublicDto[]>([]);
    const toastHandler = useContainer(ToastStateHandler);
    const [isReady, setIsReady] = useState(false);

    useEffect(() => {
        if (organizationId) {
            const { exec, abort } = clientApi.getAllForProject({
                params: { organizationId },
                onSuccess: res => {
                    setClients(res.body);
                    setIsReady(true);
                },
                onError: _ => toastHandler.push(`error`, t('common.error'), t('common.somethingWentWrong')),
            });
            exec();
            return abort;
        }
    }, [clientApi, organizationId]);

    return { clients, isReady };
};

export default useHttpGetAllClientsForProjectOnMount;
